import styles from './worlds.module.css';

const STATUS_COLORS: Record<string, string> = {
  Active: '#57f287',
  Hibernating: '#fee75c',
  Provisioning: '#5865f2',
  Waking: '#5865f2',
  Failed: '#ed4245',
  Suspended: '#ed4245',
  Deleted: '#72767d',
  Archived: '#72767d',
};

const SPINNING = new Set(['Provisioning', 'Waking']);

export function WorldStatusBadge({ status }: { status: string }): JSX.Element {
  const color = STATUS_COLORS[status] ?? '#72767d';
  const spinning = SPINNING.has(status);

  return (
    <span className={styles.badge}>
      <span
        className={spinning ? styles.spinner : styles.dot}
        style={{ background: color, borderColor: color }}
      />
      <span style={{ color }}>{status}</span>
    </span>
  );
}
